import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { PseaMinimumRequirementBlock } from "./pseaCoreStandards";

/**
 * Hover hint listing what a reviewer must actually see to score a core
 * standard, taken from the "Minimum Requirement" column of the Scoring
 * Checklist Form (Annex 3). Blocks are all required, so they are separated by
 * "AND" the way the source checklist writes them.
 *
 * `autohide={false}` keeps the tooltip open while the pointer travels onto it,
 * so the longer standards stay readable — several run to a lead-in sentence
 * plus five or six bullets.
 */
const PSEAMinimumRequirements = ({
  standardNumber,
  requirements,
}: {
  standardNumber: number;
  requirements: PseaMinimumRequirementBlock[];
}) => {
  const targetId = `psea-min-req-${standardNumber}`;

  return (
    <React.Fragment>
      <i
        id={targetId}
        className="ri-information-line text-primary fs-15 align-middle ms-1"
        style={{ cursor: "pointer" }}
        aria-label="Minimum requirements for this core standard"
      ></i>
      <UncontrolledTooltip
        placement="right"
        target={targetId}
        autohide={false}
        innerClassName="psea-min-req-tooltip"
      >
        <div className="fw-semibold mb-1">Minimum requirements</div>
        {requirements.map((block, i) => (
          <div key={i}>
            {i > 0 ? <div className="fw-semibold my-1">AND</div> : null}
            {block.text ? <div>{block.text}</div> : null}
            {block.items?.length ? (
              <ul className="mb-0 ps-3">
                {block.items.map((item, j) => (
                  <li key={j}>{item}</li>
                ))}
              </ul>
            ) : null}
          </div>
        ))}
      </UncontrolledTooltip>
    </React.Fragment>
  );
};

export default PSEAMinimumRequirements;
